var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaterialSymbolsPlayArrowRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 197,
    viewBox: "0 0 197 197",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.666 140.978V56.0218C65.666 53.6961 66.4869 51.7453 68.1285 50.1693C69.7702 48.5933 71.6855 47.808 73.8743 47.8135C74.5584 47.8135 75.278 47.9147 76.0331 48.1172C76.7883 48.3197 77.5052 48.6289 78.1837 49.0448L145.082 91.5229C146.313 92.3437 147.238 93.3698 147.856 94.601C148.474 95.8323 148.781 97.1319 148.775 98.5C148.77 99.868 148.463 101.168 147.856 102.399C147.249 103.63 146.324 104.656 145.082 105.477L78.1837 147.955C77.4997 148.366 76.7828 148.675 76.0331 148.883C75.2834 149.091 74.5638 149.192 73.8743 149.186C71.6855 149.186 69.7702 148.398 68.1285 146.822C66.4869 145.246 65.666 143.298 65.666 140.978Z",
    fill: "#f7f7f7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsPlayArrowRounded);
export default __webpack_public_path__ + "static/media/material-symbols_play-arrow-rounded.44e88e9744fcb0c93fb63bc973cf6e92.svg";
export { ForwardRef as ReactComponent };